import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=5cdd400c&"
import script from "./accountManage.vue?vue&type=script&lang=ts&"
export * from "./accountManage.vue?vue&type=script&lang=ts&"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=5cdd400c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports